import { gql } from '@apollo/client'

export const MUTATION_EXCHANGE_DEVICE = gql`
  mutation mutationExchangeDevice($input: ExchangeDeviceInput!) {
    exchangeDevice(input: $input) {
      id
    }
  }
`
